<template>
    <div class="carousel-scroll-indicator">
        <div
            class="thumb"
            :style
        ></div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const { count, scrollPercent } = defineProps<{
    count: number
    scrollPercent: number
}>()

const style = computed(() => {
    const width = 100 / count

    return {
        width: `${width}%`,
        left: `${width * scrollPercent}%`,
    }
})
</script>

<style lang="scss" scoped>
.carousel-scroll-indicator {
    position: relative;
    bottom: 0;
    width: 100%;
    height: 2px;
    display: flex;
    justify-content: center;
    padding: 0;

    .thumb {
        position: absolute;
        height: 100%;

        background-color: $blue;
    }
}
</style>
